import { render, staticRenderFns } from "./content8.vue?vue&type=template&id=eda087a6&scoped=true&"
import script from "./content8.vue?vue&type=script&lang=js&"
export * from "./content8.vue?vue&type=script&lang=js&"
import style0 from "./content8.vue?vue&type=style&index=0&id=eda087a6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda087a6",
  null
  
)

export default component.exports